import axios from "../service/axios/axios";

export default {
  //获取常见问题列表
  getArticleGroupList() {
    return axios({
      method: "post",
      url: "platform/article/getArticleGroupList",
    });
  },
  //获取常见问题分组详细列表
  getArticleList({ group_id }) {
    return axios({
      method: "post",
      url: "platform/article/getArticleList",
      data: {
        group_id,
      },
    });
  },
  //删除常见问题
  deleteArticleGroupInfo({ group_id }) {
    return axios({
      method: "post",
      url: "platform/article/deleteArticleGroupInfo",
      data: {
        group_id,
      },
    });
  },
  //常见问题分组排序
  editArticleGroupSort({ list }) {
    return axios({
      method: "post",
      url: "platform/article/editArticleGroupSort",
      data: {
        list,
      },
    });
  },
  //常见问题排序
  editArticleSort({ list }) {
    return axios({
      method: "post",
      url: "platform/article/editArticleSort",
      data: {
        list,
      },
    });
  },

  //保存图文分组信息
  saveArticleGroupInfo(data) {
    return axios({
      method: "post",
      url: "platform/article/saveArticleGroupInfo",
      data: data,
    });
  },
  //获取图文信息
  //（1医生注册协议，2患者使用协议，3药房入驻协议，4药师入驻协议，5提现协议，6隐私政策，7视频录制指南，8患教文章，9开方指南）
  getArticleInfo({ art_id }) {
    return axios({
      method: "post",
      url: "platform/article/getArticleInfo",
      data: {
        art_id,
      },
    });
  },
  //（1医生注册协议，2患者使用协议，3药房入驻协议，4药师入驻协议，5提现协议，6隐私政策，7视频录制指南，8患教文章，9开方指南）
  //添加/编辑 图文信息
  saveArticleInfo(data) {
    return axios({
      method: "post",
      url: "platform/article/saveArticleInfo",
      data: data,
    });
  },
  //删除 图文信息
  deleteArticleInfo({ art_id }) {
    return axios({
      method: "post",
      url: "platform/article/deleteArticleInfo",
      data: { art_id },
    });
  },
  //获取名家医案列表
  getFamousMedicalRecordsList() {
    return axios({
      method: "post",
      url: "platform/library/getFamousMedicalRecordsList",
    });
  },
  //名家医案排序
  editFamousMedicalRecordsSort({ list }) {
    return axios({
      method: "post",
      url: "platform/library/editFamousMedicalRecordsSort",
      data: {
        list,
      },
    });
  },
  //获取名家医案信息
  getFamousMedicalRecordsInfo({ art_id }) {
    return axios({
      method: "post",
      url: "platform/library/getFamousMedicalRecordsInfo",
      data: {
        art_id,
      },
    });
  },
  //保存名家医案信息
  saveFamousMedicalRecordsInfo(data) {
    return axios({
      method: "post",
      url: "platform/library/saveFamousMedicalRecordsInfo",
      data: data,
    });
  },
  //删除名家医案信息
  deleteFamousMedicalRecordsInfo({ art_id }) {
    return axios({
      method: "post",
      url: "platform/library/deleteFamousMedicalRecordsInfo",
      data: { art_id },
    });
  },
  //修改名家医案状态 2发布，3下架3
  changeFamousMedicalRecordsStatus({ art_id, status }) {
    return axios({
      method: "post",
      url: "platform/library/changeFamousMedicalRecordsStatus",
      data: { art_id, status },
    });
  },

  //获取每日中药列表
  getDailyChineseMedicineList() {
    return axios({
      method: "post",
      url: "platform/library/getDailyChineseMedicineList",
    });
  },
  //每日中药排序
  editDailyChineseMedicineSort({ list }) {
    return axios({
      method: "post",
      url: "platform/library/editDailyChineseMedicineSort",
      data: {
        list,
      },
    });
  },
  //获取每日中药信息
  getDailyChineseMedicineInfo({ art_id }) {
    return axios({
      method: "post",
      url: "platform/library/getDailyChineseMedicineInfo",
      data: {
        art_id,
      },
    });
  },
  //保存每日中药信息
  saveDailyChineseMedicineInfo(data) {
    return axios({
      method: "post",
      url: "platform/library/saveDailyChineseMedicineInfo",
      data: data,
    });
  },
  //删除每日中药信息
  deleteDailyChineseMedicineInfo({ art_id }) {
    return axios({
      method: "post",
      url: "platform/library/deleteDailyChineseMedicineInfo",
      data: { art_id },
    });
  },
  //修改每日中药状态 2发布，3下架3
  changeDailyChineseMedicineStatus({ art_id, status }) {
    return axios({
      method: "post",
      url: "platform/library/changeDailyChineseMedicineStatus",
      data: { art_id, status },
    });
  },
  /* ------- 报表 ------- */
  // 获取报表列表
  getReportList(data) {
    return axios({
      method: "post",
      url: "platform/library/getReportList",
      data: data,
    });
  },
  // 报表排序
  editReportSort(data) {
    return axios({
      method: "post",
      url: "platform/library/editReportSort",
      data: data,
    });
  },
  // 保存报表信息
  saveReportInfo(data) {
    return axios({
      method: "post",
      url: "platform/library/saveReportInfo",
      data: data,
    });
  },
  // 修改报表状态
  changeReportStatus(data) {
    return axios({
      method: "post",
      url: "platform/library/changeReportStatus",
      data: data,
    });
  },
  // 删除报表状态
  deleteReportInfo(data) {
    return axios({
      method: "post",
      url: "platform/library/deleteReportInfo",
      data: data,
    });
  },
  /* ------- 医生资讯 ------- */
  // 获取医生资讯列表
  getDoctorInfoList(data) {
    return axios({
      method: "post",
      url: "platform/library/getDoctorInfoList",
      data: data,
    });
  },
  // 医生资讯列表排序
  editDoctorInfoSort(data) {
    return axios({
      method: "post",
      url: "platform/library/editDoctorInfoSort",
      data: data,
    });
  },
  // 新增医生资讯
  saveDoctorInfo(data) {
    return axios({
      method: "post",
      url: "platform/library/saveDoctorInfo",
      data: data,
    });
  },
  // 编辑医生资讯
  editDoctorInfo(data) {
    return axios({
      method: "post",
      url: "platform/library/editDoctorInfo",
      data: data,
    });
  },
  // 修改医生资讯状态
  changeDoctorInfoStatus(data) {
    return axios({
      method: "post",
      url: "platform/library/changeDoctorInfoStatus",
      data: data,
    });
  },
  // 删除医生资讯信息
  deleteDoctorInfo(data) {
    return axios({
      method: "post",
      url: "platform/library/deleteDoctorInfo",
      data: data,
    });
  },
  // 添加医生资讯分类
  saveDoctorCategoryInfo(data) {
    return axios({
      method: "post",
      url: "platform/library/saveDoctorCategoryInfo",
      data: data,
    });
  },
  // 编辑医生资讯分类
  editDoctorCategoryInfo(data) {
    return axios({
      method: "post",
      url: "platform/library/editDoctorCategoryInfo",
      data: data,
    });
  },
  // 删除医生资讯分类信息
  deleteDoctorCategoryInfo(data) {
    return axios({
      method: "post",
      url: "platform/library/deleteDoctorCategoryInfo",
      data: data,
    });
  },
  // 获取咨询分类列表
  getDoctorInfoCategoryList(data) {
    return axios({
      method: "post",
      url: "platform/library/getDoctorInfoCategoryList",
      data: data,
    });
  },
  // 修改医生资讯阅读量
  changeDoctorInfoReadNum(data) {
    return axios({
      method: "post",
      url: "platform/library/changeDoctorInfoReadNum",
      data: data,
    });
  },
  /* ------- 医生教程 ------- */
  // 查看医生教程列表
  doctortutorialGetList(data) {
    return axios({
      method: "post",
      url: "platform/Doctortutorial/getList",
      data: data,
    });
  },
  // 添加教程
  doctortutorialAdd(data) {
    return axios({
      method: "post",
      url: "platform/Doctortutorial/add",
      data: data,
    });
  },
  // 编辑教程
  doctortutorialModify(data) {
    return axios({
      method: "post",
      url: "platform/Doctortutorial/modify",
      data: data,
    });
  },
  // 教程做排序操作
  doctortutorialSetSort(data) {
    return axios({
      method: "post",
      url: "platform/Doctortutorial/setSort",
      data: data,
    });
  },
  // 发布或下架教程
  doctortutoriaOnoff(data) {
    return axios({
      method: "post",
      url: "platform/Doctortutorial/onoff",
      data: data,
    });
  },
  // 查看教程详情信息
  doctortutoriaGetOne(data) {
    return axios({
      method: "post",
      url: "platform/Doctortutorial/getOne",
      data: data,
    });
  },
  // 删除教程
  doctortutoriaDelete(data) {
    return axios({
      method: "post",
      url: "platform/Doctortutorial/delete",
      data: data,
    });
  },
  // 获取教程阅读列表
  tutorialReadLogList(data) {
    return axios({
      method: "post",
      url: "platform/Doctortutorial/TutorialReadLogList",
      data: data,
    });
  },
  // 教程阅读列表导出
  tutorialReadLogExport(data) {
    return axios({
      method: "post",
      url: "platform/Doctortutorial/TutorialReadLogExport",
      data: data,
    });
  },
  /* ------- 视频管理 ------- */
  // 获取视频素材详情
  getVideoInfo(data) {
    return axios({
      method: "post",
      url: "platform/Video/getVideoInfo",
      data,
    });
  },
  // 获取视频素材列表（分页）
  getVideoList(data) {
    return axios({
      method: "post",
      url: "platform/Video/getVideoList",
      data,
    });
  },
  // 创建视频素材
  createVideo(data) {
    return axios({
      method: "post",
      url: "platform/Video/create",
      data,
    });
  },
  // 编辑视频素材
  editVideo(data) {
    return axios({
      method: "post",
      url: "platform/Video/editVideo",
      data,
    });
  },
  // 删除视频素材
  deleteVideo(data) {
    return axios({
      method: "post",
      url: "platform/Video/deleteVideo",
      data,
    });
  },
  // 获取视频素材列表（分页
  getVideoList(data) {
    return axios({
      method: "post",
      url: "platform/Video/getVideoList",
      data: data,
    });
  },
  /** 获取视频分组列表 */
  getVideoGroupList(data) {
    return axios({
      method: "post",
      url: "platform/Video/getVideoGroupList",
      data: data,
    });
  },
  /** 创建视频分组列表 */
  creatVideoGroup(data) {
    return axios({
      method: "post",
      url: "platform/Video/creatVideoGroup",
      data: data,
    });
  },
  /** 获取视频分组详情 */
  getVideoGroupInfo(data) {
    return axios({
      method: "post",
      url: "platform/Video/getVideoGroupInfo",
      data: data,
    });
  },
  /** 编辑视频分组 */
  editVideoGroup(data) {
    console.log("🚀 ~ file: imgtext.js:412 ~ editVideoGroup ~ data:", data);
    return axios({
      method: "post",
      url: "platform/Video/editVideoGroup",
      data: data,
    });
  },
  /** 删除视频分组 */
  deleteVideoGroup(data) {
    return axios({
      method: "post",
      url: "platform/Video/deleteVideoGroup",
      data: data,
    });
  },
  /** 视频分组排序 */
  editVideoGroupSort(data) {
    return axios({
      method: "post",
      url: "platform/Video/editVideoGroupSort",
      data: data,
    });
  },
  /** 删除视频分组视频 */
  deleteVideoGroupVideo(data) {
    return axios({
      method: "post",
      url: "platform/Video/deleteVideoGroupVideo",
      data: data,
    });
  },
  /** 批量删除视频分组视频 */
  delVideoGroupAll(data) {
    return axios({
      method: "post",
      url: "platform/Video/delVideoGroupAll",
      data: data,
    });
  },
};
